import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white py-14">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 font-heading">Web 3.0 Soft Limited</h3>
            <p className="text-xs text-foreground-400">
              Registered in England and Wales
              <br />
              Company Registration: Web 3.0 Soft Limited
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <p className="text-foreground-300 text-sm flex items-start">
                <span className="w-5 h-5 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </span>
                <span>
                  GB 85 Great Portland Street
                  <br />
                  Westminster W1W 7LT
                </span>
              </p>
              <p className="text-foreground-300 text-sm flex items-center">
                <span className="w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0">
                  <i className="ri-phone-line text-primary-400"></i>
                </span>
                +44 7441 424350
              </p>
              <p className="text-foreground-300 text-sm flex items-center">
                <span className="w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0">
                  <i className="ri-mail-line text-primary-400"></i>
                </span>
                support@app-for-security.com
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-foreground-400 text-sm">
            &copy; 2026 Web 3.0 Soft Limited. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link
              to="/privacy-policy"
              className="text-foreground-400 hover:text-white text-sm transition-colors whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-foreground-400 hover:text-white text-sm transition-colors whitespace-nowrap"
            >
              Terms of Service
            </Link>
            <Link
              to="/refund-policy"
              className="text-foreground-400 hover:text-white text-sm transition-colors whitespace-nowrap"
            >
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}